export default "__VITE_ASSET__CWzxUr61__"